import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import Button from '../../elements-buttons/Button';
import TextButton from '../../elements-buttons/text-button';
import { FormattedMessage } from 'react-intl';
import { intlRemoveTaxTypeHeader, intlRemoveTaxCopy, intlRemoveTax } from '../data/translationsData';
import { guestVatSupportLink, hostVatSupportLink } from '../data/supportLinks';

const RemoveTaxModal = (props) => (
  <BootstrapModal
    {...props}
    modalSize="sm-size"
    modalClass="remove-tax-modal"
    onClose={() => props.closeModal('removeTaxDetailsModal')}
    header={<h3><FormattedMessage { ...intlRemoveTaxTypeHeader[props.intlDataKey] }/></h3>}
    body={
      <div className="text-gray-600 text-center">
        <div className="padding-xl-left padding-xl-right">
          <FormattedMessage { ...intlRemoveTaxCopy[props.intlDataKey] }/>
        </div>
        <a className="margin-sm-left underline" href={props.isHost ? hostVatSupportLink : guestVatSupportLink}
          target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="hosting.taxes.learn_more_link" defaultMessage="Learn more" />
        </a>
      </div>
    }
    footer={
      <div className="flex middle column">
        <div>
          <Button
            category="primary"
            isLoading={props.showRemoveBtnSpinner}
            onClick={props.removeTaxProfile}
            attributes={{ 'data-testing-id': 'edit-add-on-button' }}
          >
            <FormattedMessage {...intlRemoveTax[props.intlDataKey]} />
          </Button>
        </div>
        <div>
          <TextButton
            buttonText={<FormattedMessage
              id="hosting.remove_taxes.cancel_button_text"
              defaultMessage="Cancel" />}
            onClick={() => props.closeModal('removeTaxDetailsModal')}
            classNames='margin-lg-top'
          />
        </div>
        {
          props.error &&
          <span className="text-red">
            <FormattedMessage
              id="hosting.taxes.error_msg"
              defaultMessage="Something went wrong, please try again." />
          </span>
        }
      </div>
    }
  />
);

RemoveTaxModal.propTypes = {
  deleteItem: PropTypes.func,
  isHost: PropTypes.bool
};

export default RemoveTaxModal;
